import Rent from '@/components/pages/service/rent';
import Train from '@/components/pages/service/train';
import Copartnership from '@/components/pages/service/copartnership';

export default [
    {
        name: 'rent',
        path: '/service/rent',
        component: Rent
    },
    {
        name: 'train',
        path: '/service/train',
        component: Train
    },
    {
        name: 'copartnership',
        path: '/service/copartnership',
        component: Copartnership
    }
];



// WEBPACK FOOTER //
// ./src/router/service/service.js